module.exports = __webpack_public_path__ + "static/media/folded-map.a3b8162d.svg";